import { render, staticRenderFns } from "./reverseTriangle.vue?vue&type=template&id=bb0ca482&scoped=true&"
import script from "./reverseTriangle.vue?vue&type=script&lang=js&"
export * from "./reverseTriangle.vue?vue&type=script&lang=js&"
import style0 from "./reverseTriangle.vue?vue&type=style&index=0&id=bb0ca482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0ca482",
  null
  
)

export default component.exports